import {
  State,
  Action,
  StateContext,
  Selector,
  Store,
  Select,
} from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { Injectable } from "@angular/core";
import * as AldAnonymousActions from "./ald-anonymous.action";
import { AldAnonymousService } from "./ald-anonymous.service";
import { BannerService } from "../../shared/services/banner.service";
import { HelperService } from "../../../../src/app/services/helper/helper.service";
import { GarageSearchModel } from "../../models/garage/garageSearch";
import { HttpEventType } from "@angular/common/http";
import * as Models from "../../models/commonModels";
import * as GarageModels from "../../models/garage/garage";
import * as CarModels from "../../models/car/car";
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as DepositeModels from '../../models/deposite/deposite';
import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import * as RelocationOrderModels from '../../models/relocation-order/relocation-order';
import * as AldModels from '../../models/ald/ald';
import * as CarTypeModels from '../../models/car/carType';
import { StorageService } from '../../shared/services/storage.service';
import * as TyreParamiterModels from '../../models/tyre/tyreParameters';

export interface AldAnonymousStateModel {

  CarCheck: Models.Response<GarageVisitsModels.CarCheckModel>;
  GarageVisit: Models.Response<GarageVisitsModels.GarageVisitModel>;
  AvailableGarages: Models.ResponseList<GarageModels.GaragePreviewModel>;
  GaragePreview: Models.Response<GarageModels.GaragePreviewModel>;
  GarageVisitsPlaceList: GarageVisitsModels.GarageVisitsPlaceListModel;
  GarageBlockedDayList: GarageVisitsModels.GarageBlockedListModel;
  GagareVisitsList: Models.ResponseList<GarageVisitsModels.GarageVisitModel>;
  CarTypes: CarTypeModels.CarTypeListModel;
  VisitTyreSources: Models.ResponseList<GarageVisitsModels.VisitTyreSourceModel>;
  TyreDiameterList: Models.ResponseList<TyreParamiterModels.TyreDiameterModel>;
}


class DictionaryKeys {
  public static readonly VisitTyreSources = "VisitTyreSources";
  public static readonly CarTypes = "CarTypes";
}

@State<AldAnonymousStateModel>({
  name: "aldAnonymousState",
  defaults: {
    CarCheck: null,
    GarageVisit: null,
    AvailableGarages: null,
    GaragePreview: null,
    GarageVisitsPlaceList: null,
    GarageBlockedDayList: null,
    GagareVisitsList: null,
    CarTypes: null,
    VisitTyreSources: null,
    TyreDiameterList: null
  },
})
@Injectable()
export class AldAnonymousState {

  constructor(
    private helperService: HelperService,
    private AldAnonymousService: AldAnonymousService,
    private bannerService: BannerService,
    private storageService: StorageService
  ) { }

  @Selector()
  static CarCheck(state: AldAnonymousStateModel) {
    return state.CarCheck;
  }

  @Selector()
  static GarageVisit(state: AldAnonymousStateModel) {
    return state.GarageVisit;
  }

  @Selector()
  static AvailableGarages(state: AldAnonymousStateModel) {
    return state.AvailableGarages;
  }

  @Selector()
  static GaragePreview(state: AldAnonymousStateModel) {
    return state.GaragePreview;
  }

  @Selector()
  static GarageVisitsPlaceList(state: AldAnonymousStateModel) {
    return state.GarageVisitsPlaceList;
  }

  @Selector()
  static GarageBlockedDayList(state: AldAnonymousStateModel) {
    return state.GarageBlockedDayList;
  }

  @Selector()
  static GagareVisitsList(state: AldAnonymousStateModel) {
    return state.GagareVisitsList;
  }

  @Selector()
  static CarTypes(state: AldAnonymousStateModel) {
    return state.CarTypes;
  }

  @Selector()
  static VisitTyreSources(state: AldAnonymousStateModel) {
    return state.VisitTyreSources;
  }

  @Selector()
  static TyreDiameterList(state: AldAnonymousStateModel) {
    return state.TyreDiameterList;
  }

  @Action(AldAnonymousActions.CheckCar)
  CheckCar(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.CheckCar
  ) {
    const errorMessage = "Błąd weryfikacji rejestracji samochodu.";

    this.AldAnonymousService.checkCar(action.RegistrationNumber).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              CarCheck: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldAnonymousActions.CheckCar",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldAnonymousActions.GarageVisitCreate)
  GarageVisitCreate(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GarageVisitCreate
  ) {
    const errorMessage = 'Błąd rezerwacji nowej wizyty.';

    this.AldAnonymousService.createGarageVisit(action.GarageVisit).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Zarezerwowano nową wizytę.');

          if (ret.Message && ret.Message.length > 0) {
            this.bannerService.info(ret.Message);
          }
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            GarageVisit: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GarageVisitCreate', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(AldAnonymousActions.GaragesGet)
  GaragesGet(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GaragesGet
  ) {
    const errorMessage = "Błąd pobierania listy garaży.";


    this.AldAnonymousService.getGarages(action.Request).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              AvailableGarages: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldAnonymousActions.GaragesGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldAnonymousActions.GaragePreviewGet)
  GaragePewviewGet(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GaragePreviewGet
  ) {
    const errorMessage = "Błąd pobierania informacji o wybranym garażu.";


    this.AldAnonymousService.getGaragePreview(action.Garage).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
            GaragePreview: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldAnonymousActions.GaragePewviewGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldAnonymousActions.GetGarageVisitPlaceList)
  GetGarageVisitPlaceList(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetGarageVisitPlaceList
  ) {

    const errorMessage = 'Błąd pobierania listy miejsc serwisowych.';



    this.AldAnonymousService.getGaragePlaceList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            GarageVisitsPlaceList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('GarageVisitsActions.GetGarageVisitPlaceList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(AldAnonymousActions.GetGarageBlockedDaysList)
  GetGarageBlockedDaysList(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetGarageBlockedDaysList
  ) {

    const errorMessage = 'Błąd pobierania listy zablokowanych dni.';


    this.AldAnonymousService.getGarageBlockedDayList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            GarageBlockedDayList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('AldAnonymousActions.GetGarageBlockedDaysList', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(AldAnonymousActions.GetGarageVisitList)
  GetGarageVisitList(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetGarageVisitList
  ) {

    function patchContext(
      list: Models.ResponseList<GarageVisitsModels.GarageVisitModel>
    ) {
      context.setState(
        patch({
          GagareVisitsList: list,
        })
      );
    }

    const emptyResponse = new Models.ResponseList<GarageVisitsModels.GarageVisitModel>();

    emptyResponse.Initialize(action.Search);

    patchContext(null);

    this.AldAnonymousService.getGarageVisits(action.Search).subscribe(
      (data) => {
        if (data.Success) {

          patchContext(data);

        } else {
          patchContext(emptyResponse);
        }
      },
      (error) => {
        patchContext(emptyResponse);

        this.bannerService.error("Błąd pobierania listy umówień.");

        this.helperService.SaveException("AldAnonymousActions.GetGarageVisitList", error);
      }
    );
  }

  @Action(AldAnonymousActions.GetCarTypes)
  GetCarTypes(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetCarTypes
  ) {

    const errorMessage = 'Błąd pobierania listy typów samochodów.';

    let storageKey = DictionaryKeys.CarTypes;

    context.setState(
      patch({
        CarTypes: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.CarTypes) {
      this.AldAnonymousService.getCarTypes().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              CarTypes: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('AldAnonymousActions.GetCarTypes', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(AldAnonymousActions.GetGarageVisit)
  GetGarageVisit(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetGarageVisit
  ) {
    const errorMessage = 'Błąd odczytu szczegółów rezerwacji wizyty w serwisie..';

    this.AldAnonymousService.getGarageVisit(action.GarageVisitId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              GarageVisit: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('AldAnonymousStateModel.GetGarageVisit', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(AldAnonymousActions.GetVisitTyreSources)
  GetVisitTyreSources(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetVisitTyreSources
  ) {

    const errorMessage = 'Błąd pobierania listy żródeł opon.';

    let storageKey = DictionaryKeys.VisitTyreSources;

    context.setState(
      patch({
        VisitTyreSources: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.VisitTyreSources) {

      this.AldAnonymousService.getVisitTyreSources().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              VisitTyreSources: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('AldAnonymousActions.GetVisitTyreSources', error);

          this.bannerService.error(errorMessage);
        });

    }
  }

  @Action(AldAnonymousActions.GetTyreDiameterList)
  GetTyreDiametersList(
    context: StateContext<AldAnonymousStateModel>,
    action: AldAnonymousActions.GetTyreDiameterList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.AldAnonymousService.getTyreDiametersList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreDiameterList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('AldAnonymousActions.GetTyreDiameterList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}
